import {
  IResourceAction,
  IResourceMethod,
  Resource,
  ResourceAction,
  ResourceHandler,
  ResourceParams,
  ResourceRequestMethod
} from '@ngx-resource/core';
import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {AuthServerProvider} from '../../common.module/auth/auth-jwt.service';
/**
 * Created by MTI on 09/05/2018.
 */

@Injectable()
@ResourceParams({
  url: environment.apiBaseUrl
})
export class AuthExtendedResource extends Resource {
  apiBaseUrl: string = environment.apiBaseUrl;

  constructor(handler: ResourceHandler, private authProv: AuthServerProvider) {
    super(handler);
  }

  @ResourceAction({
    method: ResourceRequestMethod.Post,
    path: '/close_session'
  })
  logout: IResourceMethod<any, any>;

  $getHeaders(actionOptions?: IResourceAction): any | Promise<any> {
    let headers: any = super.$getHeaders();
    if (!actionOptions.auth) {
      headers = this.authProv.extendHeaders(headers);
    }
    return headers;
  }

  $getUrl(methodOptions?: IResourceAction): string | Promise<string> {
    const resPath = super.$getUrl();
    return this.apiBaseUrl + resPath;
  }
}
